import React from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';

import {
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  CONTENT_IMAGE_PLACEHOLDER,
} from '../../../../../config/constants';

import './style.scss';

const NodeActivityTeaserRegenboog = ({ entity, wide, flipped, activeFilters }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = entity.getIn(['title', 0, 'value'], '');
  const bodyStripped = entity.getIn(['body', 0, 'processed'], '').replace(/(<([^>]+)>)/ig, '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const hero = entity.getIn(['field_image', 0, 'styles'], null);
  const locationName = entity.getIn(['field_location', 0, 'entity', 'name', 0, 'value'], '');

  const dateRanges = entity.getIn(['field_date_ranges', 0, 'dates'], List());
  let firstTrainingDate = dateRanges.getIn([0, 'start', 'date'], null);
  const url = entity.getIn(['paths', currentLanguage], '/');

  // Get first upcomming training Date if a DateRange filter has been set.
  const activeDateRangeFilter = activeFilters?.field_date_ranges_value_2;
  if (activeDateRangeFilter && activeDateRangeFilter.min) {
    const firstValidDate = dateRanges.find((dateRange) => {
      const start = dateRange.getIn(['start', 'date']);
      if ((new Date(start)) > (new Date(activeDateRangeFilter.min))) {
        return start;
      }
    });
    if (firstValidDate) {
      firstTrainingDate = firstValidDate.getIn(['start', 'date']);
    }
  }

  if (wide) {
    return (
      <div className={`NodeActivityTeaser wide ${flipped ? 'flipped' : ''}`}>
        <CoreLink to={url} title={t('activity.readMore')}>
          <div className="row NodeActivityTeaser__content">
            <div className="col-12 col-md-5">
              <div className="NodeActivityTeaser__content--image">
                {hero ? (
                  <Image
                    lazyload
                    includeWebP
                    alt={title}
                    src={{
                      [SCREEN_MOBILE]: hero.getIn(['crop_4_3']),
                      [SCREEN_TABLET]: hero.getIn(['crop_4_3']),
                      [SCREEN_NORMAL]: hero.getIn(['crop_4_3']),
                    }}
                  />
                ) : <img src={CONTENT_IMAGE_PLACEHOLDER} alt="Content placeholder" />}
                <div className="NodeActivityTeaser__content--image--tip">{t('activity.redaction_tip')}</div>
              </div>
            </div>
            <div className="col-12 col-md-7">
              <div className="NodeActivityTeaser__content__body ">
                <h3>{title}</h3>
                <div className="NodeActivityTeaser__content__body__wrapper">
                  {firstTrainingDate && (
                    <div className="date">
                      <i className="icon icon-calendar icon-variant-0" />
                      <span>{format(new Date(firstTrainingDate), 'eeee, d MMMM y')}</span>
                    </div>
                  )}
                  {locationName && (
                    <div className="location">
                      <i className="icon icon-pin2 icon-variant-0" />
                      {locationName}
                    </div>
                  )}
                </div>
                <div className="truncate">
                  <WysiwygField
                    property="schema:text"
                    html={(summary !== '' ? summary : bodyStripped)} />
                </div>
                <div className="readmore">
                  {t('activity.show_this_redaction_tip')}<i className="icon icon-arrow-right icon-variant-0" />
                </div>
              </div>
            </div>
          </div>
        </CoreLink>
      </div>
    );
  }

  return (
    <div className="NodeActivityTeaser">
      <CoreLink to={url} title={t('activity.readMore')}>
        <div className="NodeActivityTeaser__content">
          <div className="NodeActivityTeaser__content--image">
            {hero ? (
              <Image
                lazyload
                includeWebP
                alt={title}
                src={{
                  [SCREEN_MOBILE]: hero.getIn(['crop_4_3']),
                  [SCREEN_TABLET]: hero.getIn(['crop_4_3']),
                  [SCREEN_NORMAL]: hero.getIn(['crop_4_3']),
                }}
              />
            ) : <img src={CONTENT_IMAGE_PLACEHOLDER} alt="Content placeholder" />}
          </div>
          <div className="NodeActivityTeaser__content__body">
            <h3>{title}</h3>
            {firstTrainingDate && (
              <div className="date">
                <i className="icon icon-calendar icon-variant-0" />
                <span>{format(new Date(firstTrainingDate), 'eeee d, MMMM y')}</span>
              </div>
            )}
            {locationName && (
              <div className="location">
                <i className="icon icon-pin2 icon-variant-0" />
                {locationName}
              </div>
            )}
            <div className="truncate">
              <WysiwygField
                property="schema:text"
                html={(summary !== '' ? summary : bodyStripped)} />
            </div>
            <div className="readmore">
              {t('activity.readMore')}<i className="icon icon-arrow-right icon-variant-0" />
            </div>
          </div>
        </div>
      </CoreLink>
    </div>
  );
};

export default NodeActivityTeaserRegenboog;
